import { Component, input } from '@angular/core';

@Component({
  selector: 'app-capital-card',
  imports: [],
  templateUrl: './capital-card.html',
  styleUrl: './capital-card.scss',
})
export class CapitalCard {
  shadow = input<'normal' | 'small'>('normal');
}
